module.exports = __webpack_public_path__ + "static/media/success_confirmation.c69f4859.svg";